import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { RemoteSourceUpdateConfigPayload } from 'api/actions/remote-source-update-config/remote-source-update-config-payload';
import { RemoteSourceUpdateConfigPathParameters } from 'api/actions/remote-source-update-config/remote-source-update-config-path-parameters';
import { RemoteSourceUpdateConfigResponse } from 'api/actions/remote-source-update-config/remote-source-update-config-response';

type RemoteSourceUpdateConfigQueryParameters = Record<string, any>;

/**
 * The path of the RemoteSourceUpdateConfig action.
 */
export const remoteSourceUpdateConfigActionPath = new SweetPath<keyof RemoteSourceUpdateConfigPathParameters>(
  '/api/remote-source/config/{remoteSourceId}',
  { path: '{param}' }
);

/**
 * Creates a contextualized RemoteSourceUpdateConfig actions.
 */
export default function createRemoteSourceUpdateConfigAction(axios: AxiosInstance) {
  return function remoteSourceUpdateConfigAction({
    headers = {},
    parameters,
    query = {},
    payload,
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    parameters: RemoteSourceUpdateConfigPathParameters;
    query?: RemoteSourceUpdateConfigQueryParameters;
    payload: RemoteSourceUpdateConfigPayload;
  }) {
    const path = remoteSourceUpdateConfigActionPath.insert(parameters);

    return axios.request<RemoteSourceUpdateConfigResponse, RemoteSourceUpdateConfigResponse>({
      method: 'put',
      url: path,
      params: query,
      data: payload,
      headers,
    });
  };
}
